import axios from "axios";
import { API } from "@/lib/api";

export const prod = axios.create({ baseURL: `${API}/production`, withCredentials: true });
export const host = axios.create({ baseURL: `${API}/host`, withCredentials: true });

export const errMsg = (e, fallback) => (e && e.response && e.response.data && typeof e.response.data.detail === "string" ? e.response.data.detail : fallback);

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
export const fmtMB = (b) => (b < 102400 ? `${Math.max(1, Math.round(b / 1024))} KB` : `${(b / 1048576).toFixed(1)} MB`);
export const pages = (n) => `${n} A4 page${n === 1 ? "" : "s"}`;

export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
